// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  width: 100%;
  padding: 0;
  min-height: 40vh;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.settings-title {
  margin-bottom: 0;
}

.settings-section-title {
  margin-bottom: var(--space-4);
}

.settings-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.settings-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.settings-label {
  font-weight: 600;
  color: var(--color-dark-gray);
}

.settings-chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.settings-error {
  color: var(--color-warning-red);
}

.settings-actions {
  margin-top: var(--space-2);
}

.settings-danger-zone {
  border-color: color-mix(in srgb, var(--color-warning-red) 32%, transparent) !important;
  background: var(--color-pastelle-red) !important;
}

.settings-danger-text {
  color: var(--color-dark-gray);
  margin-bottom: var(--space-4);
  max-width: 520px;
}

.settings-delete-btn {
  border-color: var(--color-warning-red);
  color: var(--color-warning-red);
}

.settings-delete-btn:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--color-warning-red) 14%, transparent);
}

.settings-delete-modal {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.settings-delete-instruction {
  margin-top: 4px;
}

.settings-delete-input {
  margin-top: var(--space-2);
}

@media (max-width: 768px) {
  .settings-container {
    gap: var(--space-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sFAAsF;EACtF,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".settings-page {\n  width: 100%;\n  padding: 0;\n  min-height: 40vh;\n}\n\n.settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.settings-title {\n  margin-bottom: 0;\n}\n\n.settings-section-title {\n  margin-bottom: var(--space-4);\n}\n\n.settings-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.settings-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.settings-label {\n  font-weight: 600;\n  color: var(--color-dark-gray);\n}\n\n.settings-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n}\n\n.settings-error {\n  color: var(--color-warning-red);\n}\n\n.settings-actions {\n  margin-top: var(--space-2);\n}\n\n.settings-danger-zone {\n  border-color: color-mix(in srgb, var(--color-warning-red) 32%, transparent) !important;\n  background: var(--color-pastelle-red) !important;\n}\n\n.settings-danger-text {\n  color: var(--color-dark-gray);\n  margin-bottom: var(--space-4);\n  max-width: 520px;\n}\n\n.settings-delete-btn {\n  border-color: var(--color-warning-red);\n  color: var(--color-warning-red);\n}\n\n.settings-delete-btn:hover:not(:disabled) {\n  background-color: color-mix(in srgb, var(--color-warning-red) 14%, transparent);\n}\n\n.settings-delete-modal {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.settings-delete-instruction {\n  margin-top: 4px;\n}\n\n.settings-delete-input {\n  margin-top: var(--space-2);\n}\n\n@media (max-width: 768px) {\n  .settings-container {\n    gap: var(--space-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
